import React from "react";
import { useTranslation } from "react-i18next";
import emptyIllustration from "../../assets/images/notificationsEmpty.svg";

const NotificationEmptyState: React.FC = () => {
  const { t } = useTranslation("notifications");

  return (
    <div className="flex flex-col items-center gap-3 text-center">
      <img
        src={emptyIllustration}
        alt=""
        className="h-auto w-[72px]"
        draggable={false}
      />
      <p className="text-xs font-medium text-[#6B7280]">{t("empty_state_title")}</p>
    </div>
  );
};

export default NotificationEmptyState;
